import axios from 'axios'
import { VENDAS_CORE_BFF_ENDPOINT } from 'shared/envs'

import { httpClientFactory } from '~/domains/platform/infra/http/http-client-factory'
import { keysToSnakecase, transformResponse } from '~/domains/platform/infra/http/http-helpers'
import { responseUnauthorizedAccessInterceptor } from '~/domains/platform/infra/http/interceptors/unauthorized-access-interceptor'

export const httpClientVendasCoreBff = httpClientFactory({
  baseURL: VENDAS_CORE_BFF_ENDPOINT(),
  transformResponse: [...(axios.defaults.transformResponse as any[]), transformResponse],
  transformRequest: [keysToSnakecase, ...(axios.defaults.transformRequest as any[])],
  responseErrorInterceptors: [responseUnauthorizedAccessInterceptor]
})
